import React from 'react';

export const Money = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
    <path
      d="M6.37207 5.99983C6.37207 7.3622 7.84686 8.21368 9.02675 7.5325C9.5743 7.21637 9.91164 6.63217 9.91164 5.99983C9.91164 4.63746 8.43685 3.78598 7.25696 4.46716C6.70941 4.78329 6.37207 5.36758 6.37207 5.99983Z"
      stroke="currentColor"
    />
    <path
      d="M0.642578 10.4245V1.57556H15.6426V10.4244L0.642578 10.4245Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
